import mapboxgl from "mapbox-gl";
// Mapbox access token using for staging/production
mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_ACCESS_TOKEN;
export { mapboxgl };
